import "@a11y/focus-trap";
import "../components/overlay/overlay";
import "../components/button/button";
import "../components/icon/icon";
import "../components/themes-switcher/themes-switcher";
import "../components/toast/toasts-stack";
import "../components/menu/menu";

import * as Sentry from "@sentry/browser";

import { tryStoreHttpReferer } from "../utils/referer";
import { tryStoreUtmParameters } from "../utils/utm-parameters";
import { startPrefetch } from "../utils/prefetch";
import { initializeNavigation } from "./navigation";
import { setLocale } from "./localization/configure";
import { getConfiguration, getCurrentLanguageCode } from "../utils/configuration";
import { registerGlobalStatsEvents } from "./global-stats-events";
import { showGlobalToast } from "./global-toasts";
import { Logger } from "../services/logger";

const configuration = getConfiguration();
const sentryConfiguration = configuration.sentry;
if (typeof sentryConfiguration?.dsn === "string") {
	Sentry.init({
		environment: configuration.environment,
		dsn: sentryConfiguration.dsn,
		sampleRate: 1.0,
		tracesSampleRate: 1.0,
		profilesSampleRate: 1.0,
		replaysSessionSampleRate: configuration.environment === "Development" ? 1.0 : 0.0005,
		replaysOnErrorSampleRate: 1.0,
		debug: configuration.environment === "Development",
		attachStacktrace: true,
		integrations: [
			Sentry.captureConsoleIntegration({
				levels: ["error"],
			}),
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
			}),
			Sentry.thirdPartyErrorFilterIntegration({
				filterKeys: ["oz-webui-rVpzXBBF4QLpcpVq6iNX60n6gyNQY8"],
				behaviour: "drop-error-if-contains-third-party-frames",
			}),
		],
	});
}

setLocale(getCurrentLanguageCode()).catch((err) => Logger.error(err));

const url = new URL(window.location.href);

initializeNavigation();
tryStoreHttpReferer();
tryStoreUtmParameters();
startPrefetch();
registerGlobalStatsEvents();
showGlobalToast(url);
